import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { ScreenReader } from '@paypalcorp/pp-react-screen-reader';
import { cx } from '@paypalcorp/pp-react-utils';
import * as styles from './styles.css';
export { styles as shimmerStyles };

var _excluded = ["as", "isInverse", "className", "hasStyleDefaults", "children"];
var Shimmer = function (_ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'div' : _ref$as,
    isInverse = _ref.isInverse,
    className = _ref.className,
    _ref$hasStyleDefaults = _ref.hasStyleDefaults,
    hasStyleDefaults = _ref$hasStyleDefaults === void 0 ? true : _ref$hasStyleDefaults,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var classNames = cx(styles.base, isInverse && styles.inverse, hasStyleDefaults && styles.defaults, className);
  return /*#__PURE__*/React.createElement(as, _extends({
    className: classNames
  }, rest, {
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement(ScreenReader, {
    as: "span",
    "data-ppui": "true"
  }, children));
};

export { Shimmer };
